import React from 'react'

import useStyles from '../Card.styles'
import Footnote from '../../../components/footnote/Footnote'

const ServiceItem = ({ title, description }) => {
  const classes = useStyles()

  return (
    <div className={classes.servicesItem}>
      <h4 className={classes.servicesItemTitle}>{title}</h4>
      <p className={classes.servicesItemDescription}>{description}</p>
    </div>
  )
}

export default function CardServices () {
  const classes = useStyles()

  return (
    <div className={classes.servicesContainer}>
      <h3 className={classes.servicesTitle}>
        The Multikrd Card puts you in control of your finances!
      </h3>
      <div className={classes.servicesItemsContainer}>
        {services.map(service => (
          <ServiceItem {...service} />
        ))}
      </div>
      <Footnote
        color='white'
        notes={[
          '¹ Success ID verification required.',
          '² Subject to Terms & Conditions.Central Bank of Kansas City does not administer nor is liable for Pay on-demand /earned wage access or tips access.'
        ]}
      />
    </div>
  )
}

const services = [
  {
    title: 'Send and Receive Transfers',
    description: 'Easily transfer money to others and receive transfers to your card account.'
  },
  {
    title: 'Free Earned Wage Access Requests²',
    description:
      'Earned Wage Access is free when you direct deposit the lesser amount between $500 or half of your paycheck to your Multikrd Card.'
  },
  {
    title: 'Physical and Digital Card Options',
    description:
      'Add your card to your Apple Wallet or Google Wallet, or keep a physical card in your wallet.'
  },
  {
    title: 'Easy Application and Quick Approval',
    description: 'Most applications are approved in minutes, making it easy to get started.'
  },
  {
    title: 'User-Friendly Management',
    description: 'Manage your card and account from our app or web platform with ease.'
  },
  {
    title: 'Dedicated Customer Support',
    description: 'Our support team is ready to assist with any questions or concerns.'
  }
]
